<div>
    <cp-sort-component #sortComponent [hidden]="hideSort" [colId]="colId" [orgColId]="orgColId" (onSortRequested)="onSortRequested($event)"></cp-sort-component>
    <app-type-ahead (selectedCustEU)="selectedCustomerEU($event)" [optionData]="optionData" [placeHolder]="placeHolder"></app-type-ahead>
</div>